export default __webpack_public_path__ + "static/media/seven_.c68edc41.jpeg";